import React, { ReactNode } from "react";
import { Dialog } from '@headlessui/react'

import {CloseIcon} from "../icons";
const Modal = ({ open, onClose, children }: { open: boolean; onClose: () => void; children: ReactNode }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <div className="bg-darkGray bg-center bg-no-repeat text-white w-full h-full absolute inset-0 p-3 z-20">
        <div className="bg-modalBG absolute inset-0 bg-center bg-no-repeat z-0" />
        <div
          className="absolute right-7 top-7 cursor-pointer hover:opacity-50 z-50 duration-150 ease-in"
          onClick={onClose}
        >
          <CloseIcon />
        </div>
        <div className="relative z-30 flex items-center justify-center h-full flex-col">{children}</div>
      </div>
    </Dialog>
  )
};

export default Modal;
